<template>
  <div class="color-view">
    <div class="box"></div>
    <div class="col main-view center-items-y">
      <div class="box-color"></div>
      <transition-group name="background-popup" mode="out-in">
        <div key="5" v-if="loaded" class="red loader"></div>
        <iframe
          key="10"
          class="item z-index-500"
          width="900"
          height="680"
          :src="$store.getters.app.profile.dashboard"
          frameborder="0"
          style="border:0"
          allowfullscreen
          @load="load"
          v-show="loaded"
        ></iframe>
      </transition-group>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loaded: false
    };
  },
  methods: {
    load() {
      setTimeout(() => {
        this.loaded = true;
      }, 500);
    }
  }
};
</script>
<style scoped>
.color-view {
  background-color: #f3f3f3ff;
}
.box {
  height: 50px;
}
.loader {
  height: 400;
  width: 900px;
}
.main-view {
  height: 610px;
  z-index: 100;
  position: relative;
  overflow: hidden;
}
.box-color {
  top: 0;
  width: 100vw;
  height: 440px;
  position: absolute;
  z-index: -1;
  background: linear-gradient(to bottom, #2852e9, #2852e9);
}
</style>